import React from 'react';
import { useNavigate } from 'react-router-dom';

const FooterMobileOnly = () => {
  const navigate = useNavigate();
  const RedirectToContactUs = () => navigate('/contactus');
  const RedirectToPrivacy = () => navigate('/privacypolicy');
  const RedirectToTerms = () => navigate('/termsofservice');
  const RedirectToMerchantTerms = () => navigate('/merchanttermsofservice');

  return (
    <div
      style={{
        marginTop: 'auto', // ⭐ pushes to bottom, no overlap
        backgroundColor: 'rgb(24, 20, 54)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12,
        height: '80px',
        flexShrink: 0,
      }}
    >
      <span style={{ fontSize: 18, color: 'white' }}>Need Help?</span>
      <button
        type='button'
        onClick={RedirectToContactUs}
        style={{
          background: '#5145cd',
          color: '#fff',
          border: 'none',
          borderRadius: 999,
          padding: '11px 22px',
          fontSize: 16,
          fontFamily: 'inherit',
          cursor: 'pointer',
          transition: 'background 0.15s',
        }}
      >
        Contact Support
      </button>
    </div>
  );
};

export default FooterMobileOnly;
